var forms = document.querySelectorAll("[data-freeform-tailwind]");
forms.forEach(function (e) {
	// console.log({e});

	// On form render
	e.addEventListener("freeform-ready", function (e) {
		var r = e.freeform;
		r.setOption("errorClassBanner", [
			"bg-red-100",
			"border",
			"border-red-400",
			"font-bold",
			"text-red-700",
			"px-4",
			"py-3",
			"rounded",
			"relative",
			"mb-4",
		]),
		r.setOption("errorClassList", [
			"errors",
			"text-red-500",
			"text-sm",
			"font-medium",
			"italic",
		]),
		r.setOption("successClassBanner", [
			"bg-green-50",
			"border",
			"border-green-600",
			"font-bold",
			"text-green-800",
			"px-4",
			"py-3",
			"rounded",
			"relative",
			"mb-4",
		]);
	}),

	// Stripe field
	e.addEventListener("freeform-stripe-appearance", function (e) {
		e.elementOptions.appearance = Object.assign(
			e.elementOptions.appearance,
			{
				variables: {
					colorPrimary: "#0d6efd",
					fontFamily:
						'-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
					fontSizeBase: "16px",
					spacingUnit: "0.2em",
					tabSpacing: "10px",
					gridColumnSpacing: "20px",
					gridRowSpacing: "20px",
					colorText: "#212529",
					colorBackground: "#ffffff",
					colorDanger: "rgb(239 68 68)",
					borderRadius: "5px",
				},
				rules: {
					".Tab, .Input": {
						border: "1px solid rgb(148 163 184)",
						boxShadow: "none",
					},
					".Tab:focus, .Input:focus": {
						border: "1px solid #0b5ed7",
						boxShadow: "none",
						outline: "0",
						transition: "border-color .15s ease-in-out",
					},
					".Label": { fontSize: "16px", fontWeight: "500" },
				},
			}
		);
	}),

	// On form submit
	e.addEventListener("freeform-on-submit", function (e) {
		var r = e.form.getAttribute("data-id");
		forms.forEach(function (e) {
			var o = e.getAttribute("data-id");
			r !== o &&
				(e
					.querySelectorAll("[data-field-errors]")
					.forEach((e) => e.remove()),
				e
					.querySelectorAll(".freeform-input")
					.forEach((e) => e.classList.remove("border-red-500")));
		});
	});
});
